<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const snippet = `
    <div class="overflow-x-auto">
      <table class="table">
        <thead class="thead">
          <tr class="tr">
            <th class="th">Column 1</th>
            <th class="th">Column 2</th>
            <th class="th">Column 3</th>
            <th class="th">Column 4</th>
            <th class="th">Column 5</th>
            <th class="th">Column 6</th>
          </tr>
        </thead>
        <tbody class="">
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data that is longer</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
        </tbody>
      </table>
    </div>
  `;

  const striped = `
    <div class="overflow-x-auto">
      <table class="table table-striped">
        <thead class="thead">
          <tr class="tr">
            <th class="th">Column 1</th>
            <th class="th">Column 2</th>
            <th class="th">Column 3</th>
            <th class="th">Column 4</th>
            <th class="th">Column 5</th>
            <th class="th">Column 6</th>
          </tr>
        </thead>
        <tbody class="">
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data that is longer</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
        </tbody>
      </table>
    </div>
  `;

  const relaxed = `
    <div class="overflow-x-auto">
      <table class="table table-relaxed">
        <thead class="thead">
          <tr class="tr">
            <th class="th">Column 1</th>
            <th class="th">Column 2</th>
            <th class="th">Column 3</th>
            <th class="th">Column 4</th>
            <th class="th">Column 5</th>
            <th class="th">Column 6</th>
          </tr>
        </thead>
        <tbody class="">
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data that is longer</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
        </tbody>
      </table>
    </div>
  `;
  const condensed = `
    <div class="overflow-x-auto">
      <table class="table table-condensed">
        <thead class="thead">
          <tr class="tr">
            <th class="th">Column 1</th>
            <th class="th">Column 2</th>
            <th class="th">Column 3</th>
            <th class="th">Column 4</th>
            <th class="th">Column 5</th>
            <th class="th">Column 6</th>
          </tr>
        </thead>
        <tbody class="">
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data that is longer</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
          <tr class="tr">
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
            <td class="td">Sample data</td>
          </tr>
        </tbody>
      </table>
    </div>
  `;
</script>

<template>
  <section id="table" class="page-section bg-white">
    <div class="container">
      <h2 class="heading heading-2 my-6">Table</h2>

      <h3 class="heading heading-3 mt-8 mb-6">Default</h3>
      {@html snippet}
      <CodeSnippet id="table" {snippet} />

      <h3 class="heading heading-3 mt-8 mb-6">Striped rows</h3>
      {@html striped}
      <CodeSnippet id="striped" snippet={striped} />

      <h3 class="heading heading-3 mt-8 mb-6">Relaxed row height</h3>
      {@html relaxed}
      <CodeSnippet id="relaxed" snippet={relaxed} />

      <h3 class="heading heading-3 mt-8 mb-6">Condensed row height</h3>
      {@html condensed}
      <CodeSnippet id="condensed" snippet={condensed} />
    </div>
  </section>
</template>
